module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      免备案服务\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('aside'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contentBox"
    }
  }, [_c('div', {
    staticClass: "mui-content"
  }, [_c('ul', {
    staticClass: "common-list-box"
  }, _vm._l((_vm.listArrs), function(item) {
    return _c('li', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "item-info remark"
    }, [_c('div', {
      staticClass: "item-top"
    }, [_c('p', {
      staticClass: "remark pull-left",
      staticStyle: {
        "max-width": "4.3rem",
        "margin-right": "0.1rem"
      }
    }, [_vm._v(_vm._s(item.domain))]), _vm._v(" "), _c('span', {
      staticClass: "item-exp"
    }, [_vm._v(_vm._s(item.ptype))]), _vm._v(" "), _c('a', {
      staticClass: "pull-right right-del del-icon act-icon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.Delete(item.type, item.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_c('div', {
      staticClass: "row1 remark"
    }, [_vm._v("\n                    别名地址：" + _vm._s(item.cname) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "row1 remark"
    }, [_vm._v("\n                    IP地址：" + _vm._s(item.ip) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "row1 remark"
    }, [_vm._v("\n                    提交日期：" + _vm._s(item.time) + "\n                  ")])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "clearfix pager-wrapper"
  }, [_c('div', {
    staticClass: "pagination",
    attrs: {
      "id": "pager"
    }
  }, [_c('span', {
    staticClass: "page-button pager-prev",
    class: {
      disabled: _vm.pager.page == 1
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, 'up')
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }), _vm._v("\n                " + _vm._s(_vm.pager.page) + "/" + _vm._s(_vm.pager.pageCount) + "\n                "), _c('span', {
    staticClass: "page-button pager-next",
    class: {
      disabled: _vm.pager.page == _vm.pager.pageCount
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, "down")
      }
    }
  }, [_vm._v("下一页")])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "large-add-button"
  }, [_c('a', {
    attrs: {
      "href": "/#/user/addfreebeian"
    }
  }, [_c('span'), _vm._v("\n        + 提交免备案域名\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22586bab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/freebeian.vue
// module id = q97k
// module chunks = 1